<script>
import ExpenseForm from '@views/reports/expense-form';
import beforeLeaveAfterEdit from '@mixins/beforeLeaveAfterEditModal';

export default {
  components: {
    ExpenseForm,
  },
  mixins: [beforeLeaveAfterEdit],
  props: {
    value: {
      type: Number,
      default: null,
    },
    // eslint-disable-next-line
    loadedId: {
      default: null,
    },
    // eslint-disable-next-line
    report: {
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.showModal = true;
      } else {
        this.showModal = false;
      }
    },
  },
  methods: {
    submit(expense) {
      this.setUnchanged();
      this.$emit('updated', expense);
    },
    hide(bvEvt) {
      this.beforeModalClose(bvEvt, () => {
        this.setUnchanged();
        this.$refs.expenseModal.hide();
      });
    },
  },
};
</script>

<template>
  <b-modal ref="expenseModal" v-model="showModal" size="lg" hide-footer :title="$t('titles.edit_expense')" static @hide="hide" @hidden="$emit('hidden')">
    <ExpenseForm v-if="showModal" :loaded-id="loadedId" :report="report" @submitted="submit" @entity-changed="initBeforeLeave" />
  </b-modal>
</template>
